import React, { useState } from "react";

import { Button, IconButton } from "@mui/material";

import { EditIcon } from "design-system/icons";
import { useScreenSize } from "globals/hooks";
import AdditionalTripInfoDialog from "./AdditionalTripInfoDialog";
import { TemporaryPassenger } from "types";

type EditButtonProps = {
  mode: "create" | "update";
  compact?: boolean;
  trip: {
    id: string;
    totalGroupSize: number;
    note?: string;
    temporaryPassenger?: TemporaryPassenger;
    routes: {
      id: string;
      carryOnLuggage?: number;
      checkedLuggage?: number;
      oversizeLuggage?: number;
    }[];
  };
  isRoundTrip?: boolean;
};

function EditButton(props: EditButtonProps) {
  const { mode, compact, trip, isRoundTrip } = props;

  // hooks
  const { isMobileView } = useScreenSize();

  // state
  const [dialogOpen, setDialogOpen] = useState(false);

  // event handlers
  const handleClose = () => setDialogOpen(false);
  const handleOpen = () => {
    setDialogOpen(true);
  };

  return (
    <>
      {isMobileView ? (
        <IconButton
          aria-label="Edit additional trip info"
          size={compact ? "small" : "medium"}
          onClick={handleOpen}
        >
          <EditIcon size="small" />
        </IconButton>
      ) : (
        <Button
          size={compact ? "small" : "medium"}
          onClick={handleOpen}
          endIcon={<EditIcon size="small" />}
        >
          Edit
        </Button>
      )}
      <AdditionalTripInfoDialog
        mode={mode}
        onClose={handleClose}
        open={dialogOpen}
        trip={trip}
        isRoundTrip={isRoundTrip}
      />
    </>
  );
}

export default EditButton;
